// src/views/Admin/Questions/EditQuestion.js
import React, { useEffect, useState } from "react";
import {
  Card,
  CardHeader,
  CardBody,
  Container,
  Row,
  Col,
  FormGroup,
  Form,
  Input,
  Button,
} from "reactstrap";
import Header from "components/Headers/Header.js";
import { Formik, ErrorMessage } from "formik";
import * as Yup from "yup";
import { successToast, errorToast } from "components/toast";
import { useNavigate, useLocation } from "react-router-dom";
import { updateSurveyQuestionById } from "services/_survey";
import TextEditor from "components/TextEditor";

const EditQuestion = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [editData, setEditData] = useState({});

  // Get question from state passed by QuestionList.js
  useEffect(() => {
    if (location.state) {
      setEditData(location.state);
    } else {
      errorToast("No question data provided for editing.");
      navigate("/admin/questions");
    }
  }, [location.state, navigate]);

  const handleNavigate = () => {
    navigate("/admin/questions");
  };

  const handleSubmit = async (values, { resetForm }) => {
    const payload = {
      question: values.question,
      symptoms: values.symptoms,
    };
    const id = editData.id;

    if (id) {
      try {
        const data = await updateSurveyQuestionById(id, payload);
        if (data.data) {
          successToast(data.message);
          resetForm();
          navigate("/admin/questions"); // Redirect after success
        } else {
          errorToast(data.message || "Failed to update question");
        }
      } catch (err) {
        console.error(err);
        errorToast("Failed to update question");
      }
    }
  };

  const QuestionSchema = Yup.object().shape({
    question: Yup.string().required("Question text is required"),
    symptoms: Yup.string().required("Symptoms text is required"),
  });

  return (
    <>
      <Header />
      <Container className="mt--7" fluid>
        <Row>
          <Col className="order-xl-1">
            <Card className="bg-secondary shadow">
              <CardHeader className="bg-white border-0">
                <Row className="align-items-center">
                  <Col xs="8">
                    <h3 className="mb-0">
                      <i
                        className="fas fa-arrow-left"
                        style={{ paddingRight: "10px", cursor: "pointer" }}
                        onClick={handleNavigate}
                      ></i>
                      Edit Question
                    </h3>
                  </Col>
                </Row>
              </CardHeader>
              <CardBody>
                <Formik
                  enableReinitialize={true}
                  initialValues={{
                    question: editData?.question || "",
                    symptoms: editData?.symptoms || "", // new field
                  }}
                  validationSchema={QuestionSchema}
                  onSubmit={handleSubmit}
                >
                  {({ values, handleChange, handleSubmit, setFieldValue }) => (
                    <Form onSubmit={handleSubmit}>
                      <div className="pl-lg-4">
                        {/* Short question field */}
                        <Row>
                          <Col lg="12">
                            <FormGroup>
                              <label
                                className="form-control-label"
                                htmlFor="input-symptoms"
                              >
                                Question (Short Form){" "}
                                <span style={{ color: "red" }}>*</span>{" "}
                                <span
                                  style={{ fontSize: "12px", fontWeight: 400 }}
                                >
                                  (This short forms will be used/displayed in
                                  the survey result's email.)
                                </span>
                              </label>
                              <Input
                                className="form-control-alternative"
                                id="input-symptoms"
                                name="symptoms"
                                placeholder="Enter symptoms text"
                                type="text"
                                value={values.symptoms}
                                onChange={handleChange}
                              />
                              <ErrorMessage
                                name="symptoms"
                                component="div"
                                className="text-danger"
                              />
                            </FormGroup>
                          </Col>
                        </Row>

                        {/* Question Field */}

                        <Row>
                          <Col lg="12">
                            <FormGroup>
                              <label
                                className="form-control-label"
                                htmlFor="input-question"
                              >
                                Question <span style={{ color: "red" }}>*</span>
                              </label>
                              <div className="custom-quill">
                                <TextEditor
                                  value={values.question}
                                  onChange={(val) =>
                                    setFieldValue("question", val)
                                  }
                                  placeholder="Enter question text..."
                                  height={250}
                                />
                              </div>
                              <ErrorMessage
                                name="question"
                                component="div"
                                className="text-danger"
                              />
                            </FormGroup>
                          </Col>
                        </Row>
                      </div>

                      {/* Submit */}
                      <div className="pl-lg-4">
                        <Button color="primary" type="submit">
                          Save
                        </Button>
                      </div>
                    </Form>
                  )}
                </Formik>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default EditQuestion;
